/**
 * The external dependencies.
 */
import React from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
/**
 * The internal dependencies.
 */
import FlexRootWrapper from '../../../components/general/flex-root';
import Title from '../../../components/task/working/report/title';
import Bar from '../../../components/task/working/bar';
import Header from '../../../components/task/working/report/header';
import Description from '../../../components/task/working/report/description';
import Camera from '../../../components/task/working/report/camera';
import Step from '../../../components/task/working/report/step';
import Quantity from '../../../components/task/working/report/quantity';
import Actions from '../../../components/task/working/report/actions';
import Button from '../../../components/general/button';
import Completed from '../../../components/task/working/report/completed';
import {initArray} from '../../../common/utilities';
import {getAuthUser} from '../../../store/auth/selectors';
import {getTasksCurrent, getTaskStepsLabels} from '../../../store/tasks/selectors';
import {tasksReportError, tasksUpdate} from '../../../store/tasks/actions';
import {taskViewSet} from '../../../store/task-view/actions';
import {getAllTaskWorkSteps} from "../../../store/tasks/selectors";
import {displayscrapbutton} from "../../../store/auth/selectors";

const ContentWrapper = styled(FlexRootWrapper)`
	position: relative;
	background-color: #f5f5f5;
	border: 8px solid #EA3435;
	border-top-width: 0px;
`;

const MainContentWrapper = styled(FlexRootWrapper)`
	position: relative;
	padding: 30px 14px 18px 37px;
`;

const ActionsWrapper = styled.div`
	position: absolute;
	right: 14px;
	bottom: 18px;
`;

const FlexWrapper = styled.div`
	display: flex;
	allign-items: flex-start;
`;

const WidthWrapper = styled.div`
	width: 55%;
	margin: ${({margin}) => margin ? margin : '0'};
`;

const InputWrapper = styled.div`
	position: relative;

	& + div {
		margin-left: 40px;
	}
`;

const InputTitle = styled.p`
	font-size: 20px;
	font-weight: 700;
	color: #3b3b3b;
	margin-bottom: 13px;
`;

const ScrapButton = styled(Button)`
	display: flex;
	align-items: center;
	justify-content: center;

	width: 244px;
	font-size: 19px;
	border-width: 0;
	color: ${({scrap}) => scrap ? '#fff' : '#439DD5'}
	background: ${({scrap}) => scrap ? '#f43d3d' : '#fff'};
`;

class Report extends React.Component {
    constructor() {
        super();

        this.state = {
            message: null,
            photos: initArray(3),
            step: null,
            quantity: null,
            submitted: null,
            scrap: false,
        };
    }

    updateReportDescription = ({target: {value}}) => this.setState({message: value});


    updateReportPhotos = (index, imageData) => {
        const {camera} = navigator;
        if (!camera) {
            return;
        }

        const {photos} = this.state;

        photos[index] = `data:image/png;base64,${imageData}`;
        camera.cleanup();

        this.setState({photos});
    };

    updateReportStep = (step) => {
        this.setState({step});
    };

    updateReportQuantity = (quantity) => {
        const {task} = this.props;
        // console.debug("set quant", task, quantity);
        if (quantity > task.quantity) {
            this.setState({quantity: task.quantity});
        } else {
            this.setState({quantity});
        }
    };

    submitReport = () => {
        this.completeReport();
        this.setState({submitted: true});
    };

    handleScrap = () => {
        // console.debug("Ausschuss?", this.state.scrap);
        this.setState({scrap: !this.state.scrap});
    };

    completeReport = () => {
        const {task, tasksUpdate, tasksReportError} = this.props;
        const {
            message,
            photos,
            step,
            quantity,
            scrap,
            submitted,
        } = this.state;
        tasksReportError(task.id, {message: message, photos: photos, step: step, quantity: quantity, scrap: scrap});
        tasksUpdate(task.id, {status: 'failed'});
    };

    renderCompletedScreen() {
        const {task, user} = this.props;
        const {
            message,
            photos,
            step,
            quantity,
            submitted,
        } = this.state;

        const completedData = {
            message,
            photos,
            step: step.selectionorder,
            quantity,
            user: user.fullname,
            workplace: task.place,
            taskQuantity: task.quantity,
            shortNumber: task.erpnumberSmall,
        };

        return (
            <MainContentWrapper>
                <Completed {...completedData} />
            </MainContentWrapper>
        );
    }

    renderReportForm() {
        const {task, steps, user, displayscrapbutton} = this.props;
        const {
            message,
            photos,
            step,
            quantity,
            submitted,
            scrap,
        } = this.state;

        const isActionDisabled = [message, step, quantity].filter(v => !v).length != 0;

        return (
            <MainContentWrapper>
                <WidthWrapper margin="0 0 10px">
                    <Header shortNumber={task.erpnumberSmall} quantity={task.quantity}/>
                </WidthWrapper>

                <FlexWrapper>
                    <WidthWrapper margin="0 20px 13px 0">
                        <Description handleChange={this.updateReportDescription}/>
                    </WidthWrapper>

                    <Camera
                        photos={photos}
                        handleChange={this.updateReportPhotos}
                    />
                </FlexWrapper>

                <WidthWrapper>
                    <FlexWrapper>
                        <InputWrapper>
                            <InputTitle>Arbeitschritt zuweisen:</InputTitle>

                            <Step steps={steps} handleChange={this.updateReportStep} currentTask={task}
                                  isreport={true}/>
                        </InputWrapper>

                        <InputWrapper>
                            <InputTitle>Fehlerhafte Bauteile:</InputTitle>

                            <Quantity handleChange={this.updateReportQuantity} max={task.quantity}/>
                        </InputWrapper>

                        { displayscrapbutton && <InputWrapper>
                            <InputTitle>Ausschuss:</InputTitle>

                            <ScrapButton onClick={this.handleScrap} scrap={scrap}>
                                {scrap
                                    ? 'JA'
                                    : 'NEIN'
                                }
                            </ScrapButton>

                        </InputWrapper>}
                    </FlexWrapper>
                </WidthWrapper>

                <ActionsWrapper>
                    <Actions disabled={isActionDisabled} handleClick={this.submitReport}/>
                </ActionsWrapper>
            </MainContentWrapper>
        );
    }


    render() {
        const {task, taskViewSet} = this.props;
        const {submitted} = this.state;

        return (
            <FlexRootWrapper>
                <Title close={() => taskViewSet('')}/>

                <ContentWrapper>
                    <Bar task={task} longNumber={task.erpnumber} client={task.order_client} spread={true}/>

                    {submitted
                        ? this.renderCompletedScreen()
                        : this.renderReportForm()
                    }
                </ContentWrapper>
            </FlexRootWrapper>
        );
    }
}

export default connect(
    (state) => ({
        task: getTasksCurrent(state),
        steps: getAllTaskWorkSteps(state),
        user: getAuthUser(state),
        displayscrapbutton: displayscrapbutton(state),
    }), {
        taskViewSet,
        tasksUpdate,
        tasksReportError,
    }
)(Report);



// WEBPACK FOOTER //
// ./src/containers/task/working/report.js